import React from 'react';
import Col from 'react-bootstrap/Col';
import Row from 'react-bootstrap/Row';
import Container from 'react-bootstrap/Container';
import { Picture } from '../html5/Picture';
import { ImageModel } from '../../models/globals';
import { Responsive } from '../common/Responsive';
import { useIsIE } from '../../hooks/useIsIE';

interface SubCategoryTileModel {
    name: string;
    url: string;
    image: ImageModel;
    defaultImage: ImageModel;
}

interface SubCategoriesProps {
    subCategories: SubCategoryTileModel[];
}

const SubCategories: React.FC<SubCategoriesProps> = ({ subCategories }) => {
    const isIE = useIsIE();
    const testIdSuffix = 'sub-categories';
    const linkToSubCategory: React.ChangeEventHandler<HTMLSelectElement> = ({ target: { value } }) => {
        window.location.assign(value);
    };

    if (subCategories.length <= 1) return null;

    return (
        <>
            <Responsive className="overflow-hidden" viewMode="desktop-and-tablet" testIdSuffix={testIdSuffix}>
                <Row className="justify-content-center my-3 px-5 py-3" md="5">
                    {subCategories.map(({ defaultImage, image, name, url }) => {
                        return (
                            <Col className="mx-2 my-3 p-1 position-relative" key={name} md="2">
                                <Picture
                                    className="h-100 w-100"
                                    defaultImage={defaultImage}
                                    omitAlt // The text overlay (name) makes the alt redundant
                                    {...image}
                                />
                                <a
                                    href={url}
                                    className={
                                        'd-flex flex-column h-100 justify-content-center p-2 position-absolute ' +
                                        'sub-category-name text-center text-shadow text-uppercase text-white w-100'
                                    }
                                >
                                    {name}
                                </a>
                            </Col>
                        );
                    })}
                </Row>
            </Responsive>

            <Responsive viewMode="mobile" testIdSuffix={testIdSuffix}>
                <Container className="my-3 py-3">
                    <label className="w-100">
                        <h2 className="font-weight-light pb-3 text-muted">Specialties</h2>
                        <select
                            className="sub-category-select w-100"
                            // Use onBlur for IE, otherwise keyboard users can only select the first option
                            // See https://github.com/jsx-eslint/eslint-plugin-jsx-a11y/issues/398
                            onBlur={isIE ? linkToSubCategory : undefined}
                            onChange={isIE ? undefined : linkToSubCategory}
                        >
                            <option value="#">Select One</option>
                            {subCategories.map(({ name, url }) => {
                                return (
                                    <option key={url} value={url}>
                                        {name}
                                    </option>
                                );
                            })}
                        </select>
                    </label>
                </Container>
            </Responsive>
        </>
    );
};

export { SubCategories, SubCategoriesProps, SubCategoryTileModel };
